import * as Yup from 'yup';

const validateEmail = (message) => {
  return Yup.string().email('Must be a valid email').max(255).required(message);
};

export const isClientRole = (role) => role?.name?.includes('CLIENT') ?? false;

const requiredForClientRole = (fieldTestId) =>
  Yup.string()
    .nullable()
    .test(fieldTestId, 'required', function (value) {
      const isEdit = this.from?.[1]?.value?.edit;
      if (isEdit || !isClientRole(this.parent.role)) {
        return true;
      }
      return Boolean(value?.trim());
    });

export const Schema = Yup.object().shape({
  account: Yup.object().shape({
    firstName: Yup.string().required('required'),
    lastName: Yup.string().required('required'),
    gender: Yup.number().required('required'),
    email: validateEmail('Email is required'),
    birthDay: Yup.date().required(),
    username: Yup.string().required('required'),
    password: Yup.string().required('Password is required'),
    passwordConfirmation: Yup.string()
      .required('Password Confirmation is Required')
      .oneOf([Yup.ref('password'), null], 'Password must match')
  }),
  user: Yup.object().shape({
    role: Yup.object().nullable(),
    orgName: requiredForClientRole('org-name-required-for-client-role'),
    agencyclient: requiredForClientRole('agencyclient-required-for-client-role'),
    agencyoffice: Yup.string().nullable(),
    ssnlastfour: Yup.string().nullable()
  }),
  portalUserList: Yup.array().nullable(),
  status: Yup.string().nullable(),
  edit: Yup.boolean().nullable(),
  personId: Yup.string().nullable(),
  token: Yup.string().nullable()
});

export const initialValues = {
  edit: false,
  account: {
    username: '',
    firstName: '',
    middleName: '',
    lastName: '',
    gender: 2,
    email: '',
    birthDay: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
    password: '',
    passwordConfirmation: ''
  },
  user: {
    role: { name: 'CLIENT', roleId: 4 },
    orgName: '',
    agencyclient: '',
    agencyoffice: '',
    ssnlastfour: '',
    status: 'N'
  },
  token: '',
  portalUserList: [],
  status: 'N',
  personId: ''
};
